var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user)?_c('div',{staticClass:"dashboard__container"},[_c('div',{staticClass:"dashboard__container--body"},[_c('div',{staticClass:"dashboard__container--body--col"},[_c('ProfileEmergency',{attrs:{"user":_vm.user}})],1)])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }